import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cert-form',
  templateUrl: './cert-form.component.html',
  styleUrls: ['./cert-form.component.scss']
})
export class CertFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
